export const roundoffAmount = (amount) => {
    return Math.round(amount);
}

export const roundToTwoDecimals = (amount) => {
    return Math.round(amount * 100) / 100;
}